module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "top center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a7c455"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 339
// module chunks = 1